import {NEVER, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {Injectable} from '@angular/core';

import * as APIM from '@common/utils/dist/models/api-messages.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {EntryUtilsPL2 as EU} from '@common/utils/dist/utils/entry-utils-pl2.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';

import {EntryStore} from '@stores/entry.store';
import {EntryStoreUtils as ESU} from '@utils/entry-store-utils';
import {
  WebsocketMessageProcessor,
  WSMessageProcessorInput,
  WSMessageProcessorOutput,
} from './websocket-message-processor';
import {WSMessageReceiverService} from '@services/ws-message-receiver.service';
import {ReceiveDeactivatedEntriesTransformer} from '@stores/entry-store-transformers/receive-deactivated-entries-transformer';

@Injectable()
export class EntryDeactivatedMessageProcessor implements WebsocketMessageProcessor {
  constructor(
    private entryStore: EntryStore,
    private wsMessageReceiverService: WSMessageReceiverService,
    private receiveDeactivatedEntriesTransformer: ReceiveDeactivatedEntriesTransformer,
  ) {}

  processMessage(
    params: WSMessageProcessorInput,
  ): Observable<WSMessageProcessorOutput> {
    const message = params.msg;
    if (message.int === APIM.EventIntent.EntryDeactivated) {
      return this.wsMessageReceiverService
        .receive<APIM.NotifyRequest>(message)
        .pipe(
          map((request: APIM.NotifyRequest) => {
            if (
              !Array.isArray(request.c) ||
              request.c.length === 0 ||
              !EU.isEntryLike(request.c[0])
            ) {
              params.wsAPI.result(message, request);
              return;
            }
            const formattedEntries = (<PL2.AnyEntry[]>request.c)
              .filter((e) => ESU.isKnownEntry(e, this.entryStore.state()))
              .map((e) => ESU.formatEntry(e))
              .sort((a, b) =>
                KU.stringFromKey(a as PL2.EntryId) >
                KU.stringFromKey(b as PL2.EntryId)
                  ? 1
                  : -1,
              );

            this.entryStore.modifyStateWithTransformer(
              formattedEntries as PL2.AnyPartialEntryWithId[],
              this.receiveDeactivatedEntriesTransformer,
            );
            params.wsAPI.result(message, request);
          }),
          map(() => true),
        );
    }
    return NEVER;
  }
}
